module.exports = __webpack_public_path__ + "img/SafeTitan.b447f7e4.png";